import {InputAdornment, SxProps, Theme} from "@mui/material";
import {Box, Colors, IconSearch} from "@bounce/shared/ui";
import {OutlinedInput} from "./OutlinedInput";

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  sx?: SxProps<Theme>;
};

export const SearchInput = ({value, onChange, placeholder, sx}: Props) => (
  <OutlinedInput
    value={value}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    size="small"
    startAdornment={
      <InputAdornment position="start">
        <Box component={IconSearch} sx={{width: 16, height: 16, "& path": {stroke: Colors.grey._600}}} />
      </InputAdornment>
    }
    sx={{
      width: 280,
      backgroundColor: Colors.tertiary._100,
      "& .MuiOutlinedInput-notchedOutline": {borderColor: Colors.tertiary._300},
      "&:hover .MuiOutlinedInput-notchedOutline": {borderColor: Colors.grey._400},
      "&.Mui-focused": {backgroundColor: Colors.bw.white},
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {borderColor: Colors.blue._800, borderWidth: "1px"},
      "& input": {fontSize: 13, py: 1},
      ...sx,
    }}
  />
);
